import Plugin from '../core/Plugin';
import { PlayerEvent } from '../PlayerEvents';
import log from 'loglevel';

/**
 * 自动切线插件
 * 接收卡顿与播放器报错，二者皆有的情况下再切线
 *
 * @export
 * @class thorn
 * @extends {Plugin}
 */
export default class Switcher extends Plugin {
  constructor() {
    super();
    // 卡顿计数
    this.lagCount = 0;
    // 播放器拉流失败报错记录
    this.playerError = false;

    // cdn：默认切换CDN；resolution：业务可设置切换清晰度；
    this.changeType = 'cdn'; 
    // 所有线路列表
    this.Lines = null;
    // 当前线路索引
    this.currentLineIndex = 0;
    // 当前清晰度索引
    this.currentResolutionIndex = 0;
  }

  init(opts = {}) {
    super.init(opts);
    this._allConfig = opts;
    this.thornConfig = JSON.parse(opts[Switcher.type]);

    if (!this.thornConfig['enable']) {
      log.info('未启用卡顿切线功能');
      return;
    }
    this.changeType = this.thornConfig['changeType'] || 'cdn'; // cdn：默认切换CDN

    this._handleCareEvent();
  }

  _handleCareEvent() {
    // todo: 该方法未见使用
    this.player._changeline = this.__changeLine.bind(this);
    // 调度完成
    this.player.on(PlayerEvent.SCHEDULER_COMPLETE, this.__schedulerCompleted.bind(this));
    // 卡顿
    this.player.on('lagreport', this.__lag.bind(this));
    // 卡顿恢复
    this.player.on('lagrecover', this.__lagRecover.bind(this));
    // flv.js和hls.js内核抛出的异常或结束事件
    this.player.on(PlayerEvent.CHANGE_LINE, this.__changeLine.bind(this)); 
    this.player.on(PlayerEvent.ERROR, this.__error.bind(this));
    this.player.on(PlayerEvent.STALLED, this.__error.bind(this));
    this.player.on(PlayerEvent.PLAY, this.__play.bind(this));
  }

  __lag() {
    this.lagCount += 1;
    log.info('切线模块，收到卡顿监测计数：', this.lagCount);
    if (this.lagCount > 1 && this.playerError) {
      this.__changeLine();
    }
  }

  __lagRecover(e) {
    this.lagCount = 0;
    this.playerError = false;
  }

  __play(e) {
    this.lagCount = 0;
    // todo: hls内核播放，推流停止后，仍又触发了一次playing。此时不能忽略错误，应继续切线
    // this.playerError = false;
  }

  __error(e) {
    log.info('切线模块，收到error事件: ', e);
    if (e && e.type === 'mediaError' && (e.details === 'bufferStalledError' || e.details === 'bufferNudgeOnStall')) {
      log.info('忽略播放器错误');
      return;
    }

    this.playerError = e;
    if (this.lagCount > 1 && this.playerError) {
      this.__changeLine();
    }
  }

  __schedulerCompleted() {
    this.Lines = this.player.allDefinitionList;
  }

  async __changeLine() {
    log.info('切线模块，触发自动切线');
    let newDefObj;
    let oldDef = this.player.currentDefinition.def;
    if (this.changeType === 'cdn') {
      // 默认切换cdn
      if (this._allConfig.isLive) {
        if (this.player.player._isOpenedLiveSubtitle) {
          // 带字幕线路切换
          this.currentLineIndex += 1;
          if (this.currentLineIndex >= this.player.allDefinitionList[this.player.currentSubtitleName].length) {
            this.currentLineIndex = 0;
          }
          this.player.currentDefinitionListIndex = this.currentLineIndex;
          this.player.currentDefinitionList =
              this.player.allDefinitionList[this.player.currentSubtitleName][this.currentLineIndex];
        } else {
          // 无字幕线路切换
          this.currentLineIndex += 1;
          if (this.currentLineIndex >= this.player.allDefinitionList['original'].length) {
            this.currentLineIndex = 0;
          }
          this.player.currentDefinitionListIndex = this.currentLineIndex;
          this.player.currentDefinitionList = this.player.allDefinitionList['original'][this.currentLineIndex];
        }
      } else {
        if (this.Lines === null || this.Lines.length === 0) {
          log.error('no available line');
          return;
        }

        this.currentLineIndex += 1;
        if (this.currentLineIndex >= this.Lines.length) {
          this.currentLineIndex = 0;
        }
        this.player.currentDefinitionListIndex = this.currentLineIndex;
        this.player.currentDefinitionList = this.Lines[this.currentLineIndex];
      }

      let arr = this.player.currentDefinitionList;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i]['def'] === oldDef) {
          newDefObj = arr[i];
          break;
        }
      }
      //说明： 2023.09迪士尼项目反馈IOS-H5观看直播报错不切线，此处嫌疑添加容错
      if(!newDefObj) {
        newDefObj = arr[0];
      }
    } else {
      // 设置清晰度 原画->1080p -> 720p -> 480p -> 360p -> 原画循环，不切换到音频a；

      // 除音频之外的清晰度列表
      const definitionList = this.player.currentDefinitionList.filter(item => item.def !== 'a');
      if (definitionList.length === 0) return;

      // 当前清晰度索引
      let index = definitionList.findIndex(item => item.def === oldDef);

      // 没有当前清晰度，则从0开始
      if (index === -1) {
        index = 0;
      } else {
        // 有当前清晰度，从下一个索引开始
        index++;

        // 超出索引从头开始
        if (index > definitionList.length - 1) {
          index = 0;
        }
      }

      newDefObj = definitionList[index];

      // 是否限制不断切换最低清晰度
      // todo  默认不限制
    }

    this.lagCount = 0;
    this.playerError = false;

    // 手机全屏状态下切线会自动退出全屏，并且无法再次进入！
    if (this._allConfig.x5 && this.player.player._type !== 'NativePlayer' && this.player.isFullscreen) {
      log.info('手动退出全屏');
      // 退出全屏后不能马上切线，不然还是无法进入全屏。。。
      this.player.exitFullscreen();
      setTimeout(() => {
        this.player.currentDefinition = newDefObj;
      }, 200);
    } else {
      this.player.currentDefinition = newDefObj;
    }
    this.player.emit2All(PlayerEvent.SRC_SWITCH);
  }

  destroy() {
    super.destroy();
    this.player = null;
  }

  static get type() {
    return 'plugin_thorn';
  }
}
